/* eslint-disable react-hooks/exhaustive-deps */
import { isUrlShop, pillName, Section_Click } from "../../utils/utils";
import React, { useEffect, useRef, useState } from "react";
import ShowAllResults from "../GlobalSearchBox/ShowAllResults";
import "./SSAutoSuggestions.scss";
import { InteractiveResult } from "../SearchResults/SearchListing/InteractiveResult";
import { useSelector } from "react-redux";

const suggestionStyle = {
  cursor: "pointer",
};

function SSAutoSuggestions(props: any) {
  let timeout = useRef(setTimeout(() => { }, 0));
  
  
  const { value, resultListByFirstSuggestion, resultListSuggestions, suggestions, controller } = props;
  const [isNoResult, setNoResult] = useState(false);
  const stateDidYouMeanPrev = useSelector((state: any) => state.searchBoxReducer.stateDidYouMeanForSupportSearch);
  // Create a variable to contain the configured search result page
  const resultList  = resultListSuggestions.length > 0 ? resultListSuggestions : resultListByFirstSuggestion;
  const searchPageUrl = document.getElementById("hiddenSearchPageUrlDiv")?.getAttribute("searchPageUrl");
  const valueToHighlight = controller.state.value === value ? value : suggestions[0]?.rawValue;

  const highlightSearchTerm = (result: any) => {
    const currentTitle = result.title;
    const title = result.title?.toLowerCase();
    const searchValue = valueToHighlight?.toLowerCase();
    const index = title?.indexOf(searchValue);
    // If returned title contains the search keyword, get the mapped keyword from the returned title and highlight it
    // Otherwise, get the returned title
    const updatedResult = title.indexOf(searchValue) > -1 ? currentTitle.substring(index, index + searchValue.length) : "";
    const updatedValue = updatedResult !== "" ? currentTitle.replace(updatedResult, "<strong>" + updatedResult + "</strong>") : currentTitle;

    return updatedValue;
  }
  useEffect(() => {
    return () => {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        setNoResult(true);
      }, 0);
    };
  }, [resultListSuggestions, resultListByFirstSuggestion ]);
  
  return (
    <div className="search-hero-dropdown-wrapper">
      <div className="search-dropdown-top-Line"></div>
      <div className="upper-search-dropdown-content">
        {!suggestions.length && !resultListSuggestions.length && isNoResult &&(
          <div className="search-hero-no-results">No results found</div>
        )}
        {(stateDidYouMeanPrev || suggestions.length > 0 && resultListByFirstSuggestion.length > 0 || resultListSuggestions.length > 0 || suggestions.length > 0) && (
          <div className="search-content">

            {stateDidYouMeanPrev && (
              <>
              <div className="did-you-mean-ss-section">Did you mean: <span className="did-you-mean-value" onClick={() => { props.setIsApplyDidYouMean(true)}}>{stateDidYouMeanPrev}</span></div>
              { controller.state.value !== value && (
                <div className="top-searches-results">
                <div>NO RESULT FOR "{value}"</div>
                <div>TOP PRODUCT SUPPORT FOR SUGGESTED TERM "{suggestions[0]?.rawValue}"</div>
              </div>
              )}
              </>
            )}
            {controller.state.value === value && resultListSuggestions.length > 0 && (
              <div className="top-searches-results top-product">
              <div>{`TOP PRODUCT SUPPORT FOR "${value}"`}</div>
            </div>
            )}
            
              {(suggestions[0]?.rawValue && resultListSuggestions.length === 0 && resultListByFirstSuggestion.length > 0) && (
                <div className="top-searches-results">
                  <div>NO RESULT FOR "{value}"</div>
                  <div>TOP PRODUCT SUPPORT FOR SUGGESTED TERM "{suggestions[0]?.rawValue}"</div>
                </div>
                )}
                <div className="product-results">
                {resultList.map((suggestion: any , index: number) => {
                  const ooslValue : HTMLInputElement | null = document.querySelector("input[name=ooslPath]");
                  const ooslPath = ooslValue?.value + `?prodName=${encodeURIComponent(suggestion.title)}`;
                  const redirectPath = suggestion.clickUri;
                  return (
                    <InteractiveResult key={index} result={suggestion} redirectPath={redirectPath} sectionClick={Section_Click.SUPPORT_SEARCH}>
                      <div
                        className="product-name"
                        style={suggestionStyle}
                        dangerouslySetInnerHTML={{
                          __html: highlightSearchTerm(suggestion),
                        }}
                      >
                      </div>
                      <div className="product-support-name">
                        Product support
                      </div>
                    </InteractiveResult>
                  );
                })}
              </div>
            {suggestions.length > 0 && (
              <div className="more-support">
                <div className='top-searches-results'>
                  MORE SUPPORT FOR "{value}"
                </div>
                <div className="more-product-results">
                  {suggestions.map((suggestion: any) => {
                    return (
                      <div
                        className="product-name-suggestion"
                        id={suggestion.rawValue}
                        style={suggestionStyle}
                        key={suggestion.rawValue}
                        onClick={() => {
                          localStorage.setItem("searchSuggestion", suggestion.rawValue);
                          window.location.href = searchPageUrl + '?q=' + suggestion.rawValue + "&r=" + isUrlShop.SHOP;
                        }}
                        dangerouslySetInnerHTML={{
                          __html: suggestion.highlightedValue,
                        }}
                      ></div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {(suggestions.length > 0 || resultList.length > 0) && <ShowAllResults href={searchPageUrl + '?q=' + value + "&r=" + isUrlShop.SHOP} />}
    </div>
  );
}

export default SSAutoSuggestions;
